import DataSourcesMetrics from './DataSourcesMetrics';

export default DataSourcesMetrics;
